/* eslint-disable import/prefer-default-export */
import { gql } from "@apollo/client";

export const EXPORT_DATA_QUERY = gql`
  query EXPORT_DATA_QUERY($jobOrderIds: [Int!]!) {
    exportData(jobOrderIds: $jobOrderIds)
  }
`;
